/** Support inbox — same as paygatex landing (Footer, Contact). */
export const SUPPORT_EMAIL = 'support@paygatex.io';
